import axios from "axios";

export default {
    name: "klaim-direktur",
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getList(store, { params }) {
            const draft = axios({
                method: "get",
                url: process.env.VUE_APP_SERVICEURL + "klaim_direktur",
                params: {
                    jenis: 'Draft',
                    tlc: params.auth.username
                },
                auth: {
                    username: params.auth.username,
                    password: params.auth.password,
                },
                headers: {
                    "X-API-KEY": params.auth.apikey,
                },
            });
            const list = axios({
                method: "get",
                url: process.env.VUE_APP_SERVICEURL + "klaim_direktur",
                params: {
                    jenis: 'Laporan',
                    tlc: params.auth.username
                },
                auth: {
                    username: params.auth.username,
                    password: params.auth.password,
                },
                headers: {
                    "X-API-KEY": params.auth.apikey,
                },
            });
            return new Promise((resolve, reject) => {
                axios.all([draft, list]).then(res => {
                    const output = {
                        draft: res[0].data,
                        list: res[1].data,
                    };

                    resolve(output)
                }).catch(err => {
                    reject(err)
                })
            });
        },
    }
}